import React, { useState, ReactElement } from 'react'
import TabSelector from 'plugin-assets/shared/widget/components/tab-selector'
import styled, { css } from 'styled-components'
import theme from 'live/services/theme'
import { Configs as WidgetConfigs } from './Fields'

interface Props {
    tabs: ReactElement[]
    widgetConfig: WidgetConfigs
    changeConfig: (field: GenericValueType) => void
    changeLayoutConfig: (field: string, value: GenericValueType) => void
    isEditor: boolean
    type: string
}

export default function Configs(props: Props): ReactElement | null {
    const [tab, changeTab] = useState('channels')

    if (props.tabs.length === 0) {
        return null
    }

    const current = tab === 'chart' && props.tabs.length > 1 ? props.tabs[1] : props.tabs[0]

    const Components = current ? current.type : () => null

    return (
        <Theme>
            {props.tabs.length > 1 ? <TabSelector value={tab} onChange={changeTab} /> : null}
            <StyledSelectContainer dark={!props.isEditor}>
                <Components
                    {...current.props}
                    widgetConfig={props.widgetConfig}
                    changeConfig={props.changeConfig}
                    isEditor={props.isEditor}
                />
            </StyledSelectContainer>
        </Theme>
    )
}

export const Theme = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 100%;
    .slider-input {
        width: 210px;
    }
`

const StyledSelectContainer = styled.div`
    .input-field {
        display: flex;
        border-radius: 3px;

        > input {
            border-color: transparent;
        }
    }

    ${({ dark, isEditor }) =>
        dark && !isEditor
            ? css`
                  h3 {
                      color: #fff;
                  }

                  hr {
                      border-color: 1px solid rgb(40, 51, 74);
                  }

                  .input-config {
                      div {
                          border-color: ${theme['darker-bg']};
                          background-color: ${theme['text-color']};
                      }
                      .input-field {
                          border: 1px solid ${theme['darker-bg']};
                          background-color: ${theme['dark-bg']};
                          color: white;
                      }
                  }

                  .action-toogle > a {
                      background-color: ${theme['dark-bg']};
                  }

                  .input-field > input {
                      -webkit-box-shadow: none;
                      border-radius: 3px;
                      background-color: ${theme['dark-bg']};
                      color: ${theme.white} !important;
                  }
                  .Select-menu-outer {
                      border-color: ${theme['darker-bg']};
                  }
                  .Select-value {
                      background: ${theme['dark-bg']};

                      span.Select-value-label {
                          color: ${theme.white} !important;
                      }
                  }
                  .Select-input {
                      color: ${theme['darker-bg']};
                  }
                  .Select-control,
                  .Select-placeholder {
                      background-color: transparent;
                  }
                  .Select-placeholder {
                      color: lightgray;
                  }
                  .Select-control {
                      border-radius: 3px;
                      background-color: ${theme['dark-bg']};
                      border: solid 1px ${theme['darker-bg']};
                  }
                  .Select.is-open > .Select-control,
                  .Select-control {
                      border-radius: 3px;
                      border-color: ${theme['darker-bg']};
                      background-color: ${theme['dark-bg']};
                  }
                  .Select-option,
                  .Select-noresults {
                      background-color: ${theme['darker-bg']};
                      color: #cdd3e1;
                  }
                  .Select-option.is-focused {
                      background-color: ${theme['main-tipography']};
                      color: white;
                  }
                  .Select-menu-outer {
                      border-color: theme[ 'darker-bg' ];
                  }
                  .Select-menu {
                      &::-webkit-scrollbar {
                          width: 7px;
                          background: #0d1820;
                      }
                      &::-webkit-scrollbar-track {
                          background: #0d1820;
                          border-radius: 0;
                          margin: 1px;
                      }
                      &::-webkit-scrollbar-track-piece {
                          background: #0d1820;
                      }
                      &::-webkit-scrollbar-thumb {
                          background: ${theme['dark-bg']};
                          border-radius: 0;
                          height: 50px;
                          background-clip: padding-box;
                      }
                  }
              `
            : css`
                  .input-field {
                      border: 1px solid ${theme['light-borders']};
                  }
              `}
`
